module.exports = __webpack_public_path__ + "img/-LV4tV4OS_pBgg5c52Lv.137a7ed2.jpg";